import { createContext, useContext, useEffect, useState } from 'react';

export let AuthContext = createContext(null);

export function AuthProvider({ children }) {
  let [user, setUser] = useState(null);
  let [isPending, setIsPending] = useState(true);


  const request = async (uri, body, optionsOverride = {}) => {
    const opts = {
      ...body && {
        method: 'POST',
        body: JSON.stringify(body),
        headers: { 'content-type': 'application/json' },
        ...optionsOverride
      },
    };
    const res = await fetch(uri, opts);
    const data = await res.json();
    return {
      status: res.status,
      data,
    };
  }

  let signup = async (newUser) => {
    const { status, data } = await request('/api/user/signup', newUser);
    if (status === 200 && data.user) {
      setUser(data.user);
    } else if (data.error) {
      throw new Error(data.error);
    } else {
      throw new Error('An unknown error occurred');
    }
  };

  let signin = async (login) => {
    console.log('userDetails', login);
    const { status, data } = await request('/api/user/signin', login);
    // console.log(status, data);
    if (status === 200 && data.user) {
      setUser(data.user);
      return;
    }
    // const error = new Error(data);
    // error.status = status;
    return { status, error: data.error ? data.error : 'An unknown error occurred' };

  };


  let session = async () => {
    const { status, data } = await request('/api/user/session');
    if (status === 200 && data.user) {
      setUser(data.user);
    }
    setIsPending(false);
  };

  let signout = async () => {
    // window.location.href = '/user/'
    const { status } = await request('/api/user/signout');
    if (status === 200) {
      setUser(null);
    }
  };

  useEffect(() => {
    session();
  }, []);

  let value = { user, isPending, signin, signout, signup, request };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
